import { QuestionStatus } from './Question';
export default QuestionStatus;
